<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      center
      :close-on-click-modal="true"
      @close="handleClose"
      custom-class="dialog_normalsuo  "
      :append-to-body="true"
    >
      <div>
        <div class="detail_cont">
          <div class="flex_center margin-bottom20">
            <img
              class="imgWarning"
              src="../../assets/dialogIcoImg/noPoweIcon.png"
              alt=""
            />
          </div>
          <h3>Operation Warning</h3>
          <div class="detail_cont_text margin-top20 margin-bottom30">
            The system has found that you have engaged in abuse, crawling, and
            other situations. The system will notify the customer as soon as
            possible to resolve the issue
          </div>
        </div>
      </div>
      <div class="flex_center">
        <el-button class="btn_export" @click="handleClose()">{{
          $t("dialog.buttton.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      //page: this.currentPage

      token: sessionStorage.getItem("token"),
    };
  },
  computed: {
    newDialog: {
      get() {
        return this.suoClose;
      },
      set() {},
    },
  },
  created() {
    this.$bus.$on("show-OperationWaring-dialog", (on) => {
      this.showDialog();
    });
  },
  beforeDestroy() {
    this.$bus.$off("show-OperationWaring-dialog", this.showDialog);
  },
  methods: {
    handleClose(value) {
      this.visible = false;
    },
    showDialog(value) {
      this.visible = true;
    },
    //关闭弹窗
  },
};
</script>
<style scoped>
.imgWarning {
  width: 70px;
  height: 62px;
}
.detail_cont {
  max-height: 85vh;
  overflow: auto;
}
.detail_cont_text {
  font-size: 18px;
  line-height: 28px;
  padding: 0 !important;
}
.btn_export {
  width: 210px;
  height: 50px;
  font-size: 18px;
  border-radius: 10px;
  padding: 0 !important;
}
@media (max-width: 1920px) {
  .imgWarning {
    width: 54px;
    height: 46px;
  }
  .detail_cont_text {
    font-size: 16px;
    line-height: 24px;
  }
  .btn_export {
    width: 160px;
    height: 36px;
    font-size: 16px;
    border-radius: 5px;
  }
}
@media (max-width: 1439px) {
  .imgWarning {
    width: 48px;
    height: 42px;
  }
  .detail_cont_text {
    font-size: 14px;
    line-height: 20px;
  }
  .btn_export {
    width: 140px;
    height: 32px;
    font-size: 14px;
  }
}
</style>
